import type React from 'react';
import type { ReactElement } from 'react';
import { useRouter } from 'next/router';

import { thousandSeparated } from 'shared/util/formatting';
import type { HotelAndOffer } from '../../interfaces';
import { trackClickOfferHotel } from '../tracking/FinnAnalytics';

export const HotelResultItemPrice: React.FC<HotelAndOffer> = ({ offer, hotel }): ReactElement<HotelAndOffer> => {
    const router = useRouter();
    const { offerId, pricePerPerson } = offer;

    return (
        <>
            <div className="u-licorice u-t3 u-normal">{thousandSeparated(pricePerPerson * 2)} kr</div>
            <div className="u-d1 u-pb16">Pris per person {thousandSeparated(pricePerPerson)} kr</div>
            <a
                href={`${router.basePath}/ut?offerId=${offerId}&fromPage=hotel`}
                onClick={() => trackClickOfferHotel(offer, hotel)}
                className="button button--order u-size1of1"
                data-testid={`offerLink-${offerId}`}
                rel="noopener noreferrer nofollow"
                target="_blank">
                Gå til bestilling
            </a>
        </>
    );
};
